<!-- Configuración > Mantenimiento de módulos (16/10/2026). Patrón de tablas: table-page (admin/perfil). -->
<div class="main-content table-page table-page--compact mm-admin">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Mantenimiento de módulos</h1>
        <p class="mm-admin__lema">Pon una pantalla o una función en mantenimiento: nadie podrá usarla y quien quiera entrar verá el aviso, hasta que lo termines aquí o llegue su fecha.</p>
      </div>
      @if (!cargando() && !error()) {
        <span class="mm-admin__resumen" [class.is-on]="activos().length > 0">
          <span class="material-icons" aria-hidden="true">{{ activos().length ? "construction" : "task_alt" }}</span>
          {{ activos().length ? activos().length + " en mantenimiento" : "Todo disponible" }}
        </span>
      }
    </section>

    @if (cargando()) {
      <section class="table-page__card">
        <div class="table-page__empty table-page__empty--loading">
          <i class="material-icons" aria-hidden="true">hourglass_top</i>
          <strong>Consultando los módulos…</strong>
        </div>
      </section>
    } @else if (error()) {
      <section class="table-page__card">
        <div class="table-page__empty">
          <i class="material-icons" aria-hidden="true">error_outline</i>
          <strong>{{ error() }}</strong>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargar()">Intentar de nuevo</button>
        </div>
      </section>
    } @else {
      <section class="table-page__card">
        <div class="table-page__toolbar table-page__toolbar--filters mm-admin__barra">
          <nav class="mm-admin__pestanas" aria-label="Vistas">
            <button type="button" class="mm-admin__pestana" [class.is-on]="pestana() === 'modulos'" (click)="cambiaPestana('modulos')">
              <span class="material-icons" aria-hidden="true">view_list</span>
              Módulos
            </button>
            <button type="button" class="mm-admin__pestana" [class.is-on]="pestana() === 'bitacora'" (click)="cambiaPestana('bitacora')">
              <span class="material-icons" aria-hidden="true">history</span>
              Bitácora
            </button>
          </nav>
          @if (pestana() === "modulos") {
            <div class="table-page__filters-grid mm-admin__filtros">
              <div class="table-page__filter table-page__filter--wide">
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Buscar módulo</mat-label>
                  <input matInput type="search" maxlength="80" aria-label="Buscar módulo" [ngModel]="busqueda()"
                         (ngModelChange)="cambiaBusqueda($event)" />
                </mat-form-field>
              </div>
              <div class="table-page__filter table-page__filter--medium">
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Grupo</mat-label>
                  <mat-select [ngModel]="grupo()" (ngModelChange)="cambiaGrupo($event)">
                    <mat-option value="">Todos</mat-option>
                    @for (g of grupos(); track g) {
                      <mat-option [value]="g">{{ g }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="table-page__filter table-page__filter--medium">
                <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
                  <mat-label>Estado</mat-label>
                  <mat-select [ngModel]="filtroEstado()" (ngModelChange)="cambiaEstado($event)">
                    <mat-option value="todos">Todos</mat-option>
                    <mat-option value="mantenimiento">En mantenimiento</mat-option>
                    <mat-option value="disponibles">Disponibles</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          } @else {
            <p class="mm-admin__nota mm-admin__sub">Los movimientos más recientes: quién puso, cambió o terminó cada mantenimiento, y lo que terminó solo al llegar su fecha.</p>
          }
        </div>

        @if (pestana() === "modulos") {
          <div class="table-page__table-wrap">
            @if (visibles().length) {
              <table class="table-page__table mm-admin__tabla" #tabla [style.--mm-fila-extra]="extraFila() + 'px'">
                <thead>
                  <tr>
                    <th scope="col">Módulo</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Aviso</th>
                    <th scope="col">Vuelve</th>
                    <th scope="col" class="table-page__actions-head">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (f of visibles(); track f.opcion.clave) {
                    <tr [class.mm-admin__fila--mant]="f.activo">
                      <td>
                        <div class="mm-admin__modulo">
                          <span class="mm-admin__icono" aria-hidden="true">
                            <span class="material-icons">{{ f.opcion.icono || "widgets" }}</span>
                          </span>
                          <div class="table-page__cell-stack">
                            <span class="table-page__name">{{ f.opcion.nombre }}</span>
                            <span class="table-page__subtext mm-admin__sub">{{ f.opcion.grupo }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        @if (f.activo) {
                          <span class="table-page__status-badge is-pending mm-admin__badge mm-admin__badge--mant">En mantenimiento</span>
                        } @else {
                          <span class="table-page__status-badge is-active mm-admin__badge mm-admin__badge--libre">Disponible</span>
                        }
                      </td>
                      <td>
                        @if (f.activo; as a) {
                          <div class="table-page__cell-stack mm-admin__aviso">
                            <span class="table-page__text mm-admin__mensaje" [attr.title]="a.mensaje || porOmision">{{ a.mensaje || porOmision }}</span>
                            @if (puestoDe(a)) {
                              <span class="table-page__subtext mm-admin__sub">{{ puestoDe(a) }}</span>
                            }
                          </div>
                        } @else {
                          <span class="table-page__subtext mm-admin__sub">Todos pueden entrar.</span>
                        }
                      </td>
                      <td>
                        @if (f.activo; as a) {
                          @if (vuelveDe(a); as v) {
                            <div class="table-page__cell-stack mm-admin__vuelve">
                              <span class="table-page__text mm-admin__fecha">{{ v.fecha }}</span>
                              <span class="table-page__subtext mm-admin__sub">{{ v.hora }}</span>
                            </div>
                          } @else {
                            <span class="table-page__text mm-admin__vuelve">Cuando alguien lo termine</span>
                          }
                        }
                      </td>
                      <td class="table-page__actions">
                        @if (f.activo) {
                          <button type="button" class="table-page__action-btn" title="Cambiar el aviso"
                                  [attr.aria-label]="'Cambiar el aviso de ' + f.opcion.nombre" (click)="edita(f)">
                            <span class="material-icons" aria-hidden="true">edit</span>
                          </button>
                          <button type="button" class="table-page__action-btn mm-admin__terminar" title="Terminar el mantenimiento"
                                  [attr.aria-label]="'Terminar el mantenimiento de ' + f.opcion.nombre" (click)="termina(f)">
                            <span class="material-icons" aria-hidden="true">task_alt</span>
                          </button>
                        } @else {
                          <button type="button" class="table-page__action-btn" title="Poner en mantenimiento"
                                  [attr.aria-label]="'Poner en mantenimiento ' + f.opcion.nombre" (click)="edita(f)">
                            <span class="material-icons" aria-hidden="true">construction</span>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="table-page__empty">
                <i class="material-icons" aria-hidden="true">search_off</i>
                <strong>No hay módulos con esos filtros</strong>
                <span>Cambia la búsqueda, el grupo o el estado.</span>
              </div>
            }
          </div>

          @if (filtradas().length) {
            <div class="table-page__footer">
              <div class="table-page__meta mm-admin__sub"><span>{{ rango() }}</span></div>
              @if (totalPaginas() > 1) {
                <div class="table-page__pager">
                  <button type="button" class="table-page__pager-link" (click)="irA(numeroPagina() - 1)" [disabled]="numeroPagina() === 1">
                    Anterior
                  </button>
                  <span class="table-page__pager-page is-current">{{ numeroPagina() }} de {{ totalPaginas() }}</span>
                  <button type="button" class="table-page__pager-link" (click)="irA(numeroPagina() + 1)"
                          [disabled]="numeroPagina() === totalPaginas()">
                    Siguiente
                  </button>
                </div>
              }
            </div>
          }
        } @else {
          <div class="table-page__table-wrap">
            @if (bitacora().length) {
              <table class="table-page__table mm-admin__tabla" #tabla [style.--mm-fila-extra]="extraFila() + 'px'">
                <thead>
                  <tr>
                    <th scope="col">Cuándo</th>
                    <th scope="col">Módulo</th>
                    <th scope="col">Qué pasó</th>
                    <th scope="col">Quién</th>
                    <th scope="col">Aviso</th>
                  </tr>
                </thead>
                <tbody>
                  @for (m of bitacoraVisible(); track $index) {
                    <tr>
                      <td class="table-page__text mm-admin__fecha">{{ fechaDe(m.fecha) }}</td>
                      <td class="table-page__name">{{ m.nombre }}</td>
                      <td class="table-page__text">{{ accionDe(m) }}</td>
                      <td class="table-page__text">{{ m.usuarioNombre || (m.accion === "VENCE" ? "El COS" : "—") }}</td>
                      <td>
                        <div class="table-page__cell-stack mm-admin__aviso">
                          <span class="table-page__text mm-admin__mensaje" [attr.title]="m.mensaje || porOmision">{{ m.mensaje || porOmision }}</span>
                          @if (m.hasta) {
                            <span class="table-page__subtext mm-admin__sub">Hasta {{ fechaDe(m.hasta) }}</span>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="table-page__empty">
                <i class="material-icons" aria-hidden="true">history</i>
                <strong>Todavía no hay movimientos</strong>
                <span>Aquí queda quién puso cada módulo en mantenimiento, quién lo terminó y cuándo.</span>
              </div>
            }
          </div>

          @if (bitacora().length) {
            <div class="table-page__footer">
              <div class="table-page__meta mm-admin__sub"><span>{{ rangoBitacora() }}</span></div>
              @if (totalPaginasBitacora() > 1) {
                <div class="table-page__pager">
                  <button type="button" class="table-page__pager-link" (click)="irABitacora(numeroPaginaBitacora() - 1)"
                          [disabled]="numeroPaginaBitacora() === 1">
                    Anterior
                  </button>
                  <span class="table-page__pager-page is-current">{{ numeroPaginaBitacora() }} de {{ totalPaginasBitacora() }}</span>
                  <button type="button" class="table-page__pager-link" (click)="irABitacora(numeroPaginaBitacora() + 1)"
                          [disabled]="numeroPaginaBitacora() === totalPaginasBitacora()">
                    Siguiente
                  </button>
                </div>
              }
            </div>
          }
        }
      </section>
    }
  </div>
</div>
